export default{
  data(){
    return{
      status_map: {
        Active: { color: 'success', icon:'mdi-check',text: 'Ativo'}, 
        Inactive: { color: 'warning', icon:'mdi-alert',text: 'Inativo'}, 
        Suspended: { color: 'warning', icon:'mdi-alert',text: 'Suspendido'}, 
        Excluded: { color: 'error', icon:'mdi-delete',text: 'Excluído'}, 
        Canceled: { color: 'error', icon:'mdi-cancel',text: 'Cancelado'},
      },
    }
  },
  computed:{
    status_color_map(key){
      if( key in this.status_map){
        return this.status_map[key].color
      }else{
        return 'error'
      }
    }
  },
}